import { useState, useContext } from 'react';

import Button from '../../reusable/button/button.component';
import Input from '../../reusable/inputs/text/text-input.component';
import Spinner from '../../reusable/spinner/spinner.component';

import { ToastContext } from '../../../contexts/toast.context';
import Client from '../../../tools/client';

import {
  RowContainer
} from '../../../styles/component.styles';

const client = new Client();

const InventoryRestock = ({ inventory, onSuccess = () => {}, onCancel = () => {} }) => {
  const [quantity, setQuantity] = useState('');
  const [mode, setMode] = useState('add'); // 'add' or 'set'
  const [loading, setLoading] = useState(false);

  const { successToast, errorToast } = useContext(ToastContext);

  const handleRestock = async () => {
    const qty = Number(quantity);
    if (!quantity || isNaN(qty) || qty < 0) {
      errorToast('Please enter a valid non-negative quantity');
      return;
    }

    setLoading(true);

    try {
      const res = await client.restockInventory(inventory.id, {
        quantity: qty,
        mode
      });

      if (res?.status === 'queued') {
        successToast('Restock task successfully queued');
        onSuccess(); // trigger reload
        onCancel();  // close modal
      } else {
        errorToast(res?.message || 'Failed to queue restock');
      }
    } catch (err) {
      console.error('Restock Error:', err);
      errorToast('Unexpected error during restock');
    }

    setLoading(false);
  };

  return (
    <>
      <h3>Adjust Inventory</h3>

      <div style={{ background: '#f5f5f5', padding: '10px', borderRadius: '6px', marginBottom: '15px' }}>
        <p><strong>Product:</strong> {inventory?.Product?.name || 'N/A'}</p>
        <p><strong>SKU:</strong> {inventory?.sku || 'N/A'}</p>
        <p><strong>Size:</strong> {inventory?.size || 'N/A'}</p>
        <p><strong>Current Quantity:</strong> {inventory?.quantity ?? 'N/A'}</p>
      </div>

      <p>
        {mode === 'add'
          ? 'Enter the amount you would like to add to the current inventory.'
          : 'Enter the new quantity you want this inventory to be set to.'}
      </p>

      <div style={{ marginBottom: '10px' }}>
        <label>
          <input
            type="radio"
            name="mode"
            value="add"
            checked={mode === 'add'}
            onChange={() => setMode('add')}
          />{' '}
          Add Quantity
        </label>{' '}
        <label>
          <input
            type="radio"
            name="mode"
            value="set"
            checked={mode === 'set'}
            onChange={() => setMode('set')}
          />{' '}
          Set Inventory
        </label>
      </div>

      <Input
        type="number"
        value={quantity}
        placeholder={mode === 'add' ? 'Amount to add' : 'New total quantity'}
        onChange={(e) => setQuantity(e.target.value)}
        min="0"
      />

      <RowContainer>
        <Button variant="secondary" onClick={onCancel} style={{ marginLeft: '10px' }}>
          Cancel
        </Button>
        <Button disabled={loading} onClick={handleRestock}>
          {loading ? <Spinner small /> : 'Submit'}
        </Button>
      </RowContainer>
    </>
  );
};

export default InventoryRestock;